import { apiClient } from './client';
import { Chat, ChatPage, Message, SyncStatus } from '../types';

export const chatService = {
  syncStatus: async (): Promise<SyncStatus> => (
    await apiClient.get<SyncStatus>('/sync-status')
  ).data,
  list: async (offset = 0, limit = 50, query = ''): Promise<ChatPage> => (
    await apiClient.get<ChatPage>('/chats', { params: { offset, limit, ...(query ? { q: query } : {}) } })
  ).data,
  get: async (chatId: string): Promise<Chat> => (
    await apiClient.get<Chat>(`/chats/${encodeURIComponent(chatId)}`)
  ).data,
  messages: async (chatId: string, offset = 0, limit = 50): Promise<Message[]> => (
    await apiClient.get<Message[]>(`/chats/${encodeURIComponent(chatId)}/messages`, { params: { offset, limit } })
  ).data,
  sendText: async (chatId: string, text: string): Promise<Message> => (
    await apiClient.post<Message>(`/chats/${encodeURIComponent(chatId)}/messages`, { text })
  ).data,
  sendImage: async (chatId: string, image: File, idempotencyKey: string): Promise<Message> => {
    const form = new FormData();
    form.append('image', image);
    return (await apiClient.post<Message>(`/chats/${encodeURIComponent(chatId)}/messages/image`, form, {
      headers: { 'X-Idempotency-Key': idempotencyKey },
    })).data;
  },
  deleteMessage: async (chatId: string, messageId: string): Promise<Message> => (
    await apiClient.delete<Message>(`/chats/${encodeURIComponent(chatId)}/messages/${encodeURIComponent(messageId)}`)
  ).data,
  read: async (chatId: string): Promise<void> => { await apiClient.post(`/chats/${encodeURIComponent(chatId)}/read`); },
};
